import {useCallback, useMemo} from "react"
import {Trigger, useContentCardActions, useContentCards} from "@irati/braze"

export const useRecognitionNudge = () => {
  const {triggers} = useContentCards()
  const {markContentCardsImpression, markContentCardsDismissed} = useContentCardActions()

  const nudge = useMemo(() => triggers.find((t) => t.extras.trigger.triggerId === "celebrations_recognition_nudge"), [triggers])

  const dismissNudge = useCallback(() => {
    if (nudge) {
      markContentCardsDismissed([nudge.id])
    }
  }, [nudge, markContentCardsDismissed])

  const allowNudge = useCallback(
    (cb: (nudge?: Trigger) => void) => {
      if (nudge) {
        markContentCardsImpression([nudge.id])
      }
      cb(nudge?.extras.trigger)
    },
    [nudge, markContentCardsImpression]
  )

  return useMemo(() => ({dismissNudge, allowNudge}), [dismissNudge, allowNudge])
}
